import React from 'react';
import { withSecureServices } from 'hoc/page.hoc';
import { AUTO_INSURANCE_MARKETPLACE } from 'types/mrph.pages.constants';
import { AUTO_INSURANCE as autoInsurancePagePosition } from 'types/morph.pagePosition.constants';
import { useLinkHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';
import { useAutoInsuranceMarketplace } from './hooks/AutoInsuranceMarketplace.hook';
import { useInsurancePrefill } from './hooks/InsurancePrefill.hook';
import AutoInsuranceModuleView from './AutoInsuranceModuleView';
import InsuranceInfoForm from './components/InsuranceInfoForm';

const AutoInsuranceModuleController = props => {
  const { eventHandler, config, userInfo, datatestid, modulePosition } = props;
  const onLinkClickCallback = useLinkHandler(eventHandler);

  const aiConfig = config?.marketplace?.ai;
  const autoInsuranceMarketplace = useAutoInsuranceMarketplace(
    aiConfig,
    userInfo,
    eventHandler,
  );
  const autoInsurancePrefill = useInsurancePrefill(userInfo, eventHandler);

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      pagePosition: autoInsurancePagePosition,
      modulePosition,
      vertical: AUTO_INSURANCE_VERTICAL,
    }),
  );

  if (
    autoInsurancePrefill.statesPrefill.showUserInfoForm &&
    aiConfig?.enableInsurancePrefill
  ) {
    return (
      <InsuranceInfoForm
        {...props}
        {...autoInsuranceMarketplace}
        {...autoInsurancePrefill}
        issuerList={aiConfig?.issuerList}
        enableInsurancePrefill={aiConfig?.enableInsurancePrefill}
      />
    );
  } else {
    return (
      <AutoInsuranceModuleView
        {...props}
        {...autoInsuranceMarketplace}
        {...autoInsurancePrefill}
        seenPixel={seenPixel}
        onLinkClickCallback={onLinkClickCallback}
        datatestid={datatestid}
        issuerList={aiConfig?.issuerList}
        enableInsurancePrefill={aiConfig?.enableInsurancePrefill}
      />
    );
  }
};

export default AutoInsuranceModuleController;
